import { csx, Text } from '@vtex/admin-ui'
import { graphql } from 'babel-plugin-relay/macro'
import type { HTMLAttributes } from 'react'
import React from 'react'
import { useSuspenseFragment } from 'react-relay-offline'

import type { ShowSkuImagesGalleryButton_ProductSkuImageConnection$key } from './__generated__/ShowSkuImagesGalleryButton_ProductSkuImageConnection.graphql'
import { SKU_THUMBNAILS_ITEMS_LIMIT } from '../constants'

const productSkuImageConnectionFragment = graphql`
  fragment ShowSkuImagesGalleryButton_ProductSkuImageConnection on ProductSkuImageConnection {
    edges {
      __typename
    }
  }
`

export type ShowSkuImagesGalleryButtonProps = {
  productSkuImageConnectionRef: ShowSkuImagesGalleryButton_ProductSkuImageConnection$key
} & HTMLAttributes<HTMLDivElement>

export const ShowSkuImagesGalleryButton = ({
  productSkuImageConnectionRef,
  ...props
}: ShowSkuImagesGalleryButtonProps) => {
  const productSkuImageConnection = useSuspenseFragment(
    productSkuImageConnectionFragment,
    productSkuImageConnectionRef
  )

  const shouldRenderComponent =
    productSkuImageConnection.edges.length > SKU_THUMBNAILS_ITEMS_LIMIT

  if (!shouldRenderComponent) {
    return null
  }

  return (
    <div
      className={csx({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '$blue10',
        borderRadius: '4px',
        paddingY: '$space-4',
        cursor: 'pointer',
      })}
      {...props}
    >
      <Text variant="display" tone="info">
        {`+${
          productSkuImageConnection.edges.length - SKU_THUMBNAILS_ITEMS_LIMIT
        }`}
      </Text>
    </div>
  )
}
